export default __webpack_public_path__ + "static/media/bondisushi.2d9dbeae.jpeg";